import React from 'react';
import { Box, Chip, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

interface SpotStripProps {
  selectedId: string;
  spots: CRM.ActivitySpotDocument[];
  onChange: (value: CRM.ActivitySpotDocument) => any;
}

/**
 * Styles pour le composant SpotStrip
 * 
 * @param theme Thème Material-UI
 * @returns Styles CSS pour les chips de sites
 */
const useStyles = makeStyles((theme: Theme) => ({
  activity: {
    fontSize: '1rem',
    marginRight: theme.spacing(1),
    marginBottom: '0.3rem',
  },
  selected: {
    textDecoration: 'underline',
    backgroundColor: '#D5DADF',
  },
}));

/**
 * Composant de sélection de sites d'activités sous forme de bande
 * 
 * Ce composant affiche une liste horizontale de sites d'activités :
 * - Chips cliquables pour chaque site
 * - Mise en surbrillance du site sélectionné
 * - Support du wrap pour l'affichage responsive
 * 
 * Logique métier :
 * - Sélection visuelle du site actif avec style différent
 * - Callback onChange lors du clic sur un site
 * - Affichage du nom d'affichage de chaque site
 * 
 * @param selectedId ID du site actuellement sélectionné
 * @param spots Liste des sites d'activités disponibles
 * @param onChange Fonction appelée lors du changement de sélection
 * @returns Composant React de la bande de sites
 */
export function SpotStrip({ onChange, spots, selectedId }: SpotStripProps) {
  const classes = useStyles();

  return (
    <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'}>
      {spots.map(spot => (
        <Chip
          className={clsx(classes.activity, {
            [classes.selected]: spot._id === selectedId,
          })}
          key={spot._id}
          label={spot.displayName}
          onClick={() => onChange(spot)}
        />
      ))}
    </Box>
  );
}
